import store from "../store";

export default async function is_education_pro_retoucher({ next, router }) {
    await store.dispatch('profile/me');
    let user = await store.getters['profile/me'](Math.floor(Math.random()*1000000));
    if (!('education_pro_retoucher' in user && user.education_pro_retoucher)) {
        return router.push({ name: "User Profile" });
    }
    return next();
}
